/**
 * Cart Page JavaScript
 * Handles free shipping banner close functionality
 */

document.addEventListener('DOMContentLoaded', function () {
  const closeButton = document.querySelector('.free-shipping-banner__close');
  if (closeButton) {
    closeButton.addEventListener('click', function () {
      const banner = this.closest('.free-shipping-banner');
      if (banner) {
        banner.style.display = 'none';
      }
    });
  }
});
